import {
    cmdClear,
    cmdDeviceDesktop,
    cmdDeviceMobile,
    cmdDeviceTablet,
    cmdImport,
    cmdDeviceTabletHorizontal
} from '../consts';

export default (editor, config = {}) => {
    const { Commands } = editor;
    const txtConfirm = config.textCleanCanvas;

    Commands.add(cmdDeviceDesktop, {
        run: (ed) => ed.setDevice('Desktop'),
        stop: () => {},
    });
    Commands.add(cmdDeviceTablet, {
        run: (ed) => ed.setDevice('Tablet'),
        stop: () => {},
    });
    Commands.add(cmdDeviceMobile, {
        run: (ed) => ed.setDevice('Mobile portrait'),
        stop: () => {},
    });
       Commands.add(cmdDeviceTabletHorizontal, {
        run: (ed) => ed.setDevice('Tablet Horizontal'),
        stop: () => {},
    });
    Commands.add(
        cmdClear,
        (e) => confirm(txtConfirm) && e.runCommand('core:canvas-clear')
    );

    const pfx = editor.getConfig('stylePrefix');
    const importLabel = '';
    const importCnt = '';

    editor.Commands.add(cmdImport, {
        codeViewer: null,
        container: null,

        run(editor) {
            const currentHtml = editor.getHtml();
            const currentCss = editor.getCss();
            const codeContent = currentCss
                ? `${currentHtml}\n<style>\n${currentCss}\n</style>`
                : currentHtml;

            const codeViewer = this.getCodeViewer();
            editor.Modal.open({
                title: 'Import Code',
                content: this.getContainer(),
            }).onceClose(() => editor.stopCommand(cmdImport));

            codeViewer.setContent(codeContent || '');
            codeViewer.refresh();
            setTimeout(() => codeViewer.focus(), 0);
        },

        stop() {
            editor.Modal.close();
        },

        getContainer() {
            if (!this.container) {
                const codeViewer = this.getCodeViewer();
                const container = document.createElement('div');
                container.className = `${pfx}import-container`;

                // Import Label
                if (importLabel) {
                    const labelEl = document.createElement('div');
                    labelEl.className = `${pfx}import-label`;
                    labelEl.innerHTML = importLabel;
                    container.appendChild(labelEl);
                }

                container.appendChild(codeViewer.getElement());

                // Import button
                const btnImp = document.createElement('button');
                btnImp.type = 'button';
                btnImp.innerHTML = 'Import';
                btnImp.className = `${pfx}btn-prim ${pfx}btn-import`;
                btnImp.onclick = () => {
                    editor.Css.clear();
                    editor.setComponents(codeViewer.getContent().trim());
                    editor.Modal.close();
                };
                container.appendChild(btnImp);

                this.container = container;
            }

            return this.container;
        },

        /**
         * Return the code viewer instance
         * @returns {CodeViewer}
         */
        getCodeViewer() {
            if (!this.codeViewer) {
                this.codeViewer = editor.CodeManager.createViewer({
                    codeName: 'htmlmixed',
                    theme: 'hopscotch',
                    readOnly: false,
                });
            }

            return this.codeViewer;
        },
    });
};
